module.exports = __webpack_public_path__ + "static/media/referFriendIcon.8688db3e.svg";